"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.save = exports.search = exports.fetch = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const lib_1 = require("@caddigital/sok-types/lib/");
const actionTypes = require("../../actionTypes/modelspace/project");
const actions = require("../../actions/modelspace/project");
function fetch(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.FETCH_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/modelspace/project/${action.payload}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = lib_1.Modelspace.iProjectConfiguration.decode(response);
        const act = validation.fold((err) => actions.fetchFailed((0, errorHandling_1.parseValidationError)(err)), (res) => actions.fetchSuccess(res));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.fetch = fetch;
function search(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.SEARCH_REQUEST), (0, operators_1.switchMap)((action) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/modelspace/customer/${action.payload.configuration.customerId}/configuration/${action.payload.configuration.configurationId}/project/${action.payload.projectId}?search=${action.payload.modelspaceProjectNumber}&format=minimal`
        }).pipe((0, operators_1.mergeMap)(({ response }) => {
            const validation = lib_1.Modelspace.iProjectSearchResponseMinimal.decode(response);
            const act = validation.fold((err) => {
                return actions.searchFailed((0, errorHandling_1.parseValidationError)(err));
            }, (res) => actions.searchSuccess(res));
            return (0, rxjs_1.of)(act);
        }), (0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(actions.searchFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)));
        }));
    }));
}
exports.search = search;
function save(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.SAVE_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/modelspace/project/${action.payload.projectId}/configuration`,
        body: action.payload
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(actions.saveSuccess())), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.saveFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.save = save;
//# sourceMappingURL=project.js.map